import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../config/theme';
import Typography from '@material-ui/core/Typography';
import { numberAsCurrency } from '../utils/index';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '10px 0',
    borderRadius: '14px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #D9DDE5',
    padding: '14px 18px',
    minHeight: '128px',
    textAlign: 'left',
    boxShadow: '0 2px 7px rgba(0,0,0,0.09)',
  },
  infoContainer: {
    color: '#1A1A1A',
    padding: 0,
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    columnGap: '14px',
    rowGap: '8px',
  },
  created_at: {
    fontSize: '0.8rem',
    color: '#2F2F2F',
    textAlign: 'right',
    alignSelf: 'start',
    lineHeight: 1.1,
  },
  value: {
    fontSize: '1.15rem',
    fontWeight: 700,
    lineHeight: 1,
    color: '#316933',
    margin: 0,
    whiteSpace: 'nowrap',
  },
  status: {
    fontSize: '0.82rem',
    justifySelf: 'end',
    alignSelf: 'end',
    borderRadius: '10px',
    padding: '6px 12px',
    fontWeight: 700,
    lineHeight: 1,
  },
  description: {
    fontSize: '0.88rem',
    color: '#343434',
    margin: 0,
    gridColumn: '1 / 2',
    lineHeight: 1.2,
  },
  analysisInfo: {
    fontSize: '0.8rem',
    color: '#343434',
    fontStyle: 'italic',
    margin: 0,
    gridColumn: '1 / 3',
    lineHeight: 1.2,
  },
}));

export default function WithdrawalItem({ withdrawalRequest }) {
  const classes = useStyles();

  function statusStyle(status) {
    if (status === 'approved') {
      return { color: '#0D7D2A', backgroundColor: '#C8F4CE' };
    } else if (status === 'created' || status === 'pending') {
      return { color: '#AD7A00', backgroundColor: '#F8EFCB' };
    } else if (status === 'rejected') {
      return { color: '#B12525', backgroundColor: '#F6D3D3' };
    }
    return { color: '#4A4A4A', backgroundColor: '#ECECEC' };
  }

  function defaultDescription(status) {
    if (status === 'created') {
      return 'Seu saque está em análise pela nossa equipe.';
    } else if (status === 'rejected') {
      return 'Saque recusado. Entre em contato com o suporte.';
    }
    return 'Aguardando processamento do saque';
  }

  function textStyleForStatus(status) {
    if (status === 'approved') {
      return { color: '#2C5E2E' };
    } else if (status === 'created' || status === 'pending') {
      return { color: '#2C5E2E' };
    } else if (status === 'rejected') {
      return { color: '#2C5E2E' };
    }
    return { color: '#2C5E2E' };
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <div className={classes.infoContainer}>
          <Typography variant="h6" className={classes.value} style={textStyleForStatus(withdrawalRequest?.status)}>
            {numberAsCurrency(withdrawalRequest?.value)}
          </Typography>
          <span className={classes.created_at}>{moment(withdrawalRequest?.created_at).format('DD/MM/YY [às] HH:mm')}</span>
          <Typography variant="body1" className={classes.description}>
            {withdrawalRequest?.details || defaultDescription(withdrawalRequest?.status)}
          </Typography>
          <span className={classes.status} style={statusStyle(withdrawalRequest?.status)}>
            {withdrawalRequest?.status_t}
          </span>
          {withdrawalRequest?.status === 'created' && (
            <Typography variant="body2" className={classes.analysisInfo}>
              A análise dos documentos é concluída em até 5 dias.
            </Typography>
          )}
        </div>
      </div>
    </ThemeProvider>
  )
}